// Cookies that point the UI at a non-default bundle or backend. None of them are HttpOnly, so they can be read and
// cleared from JS. ox_ui_version is set by nginx from `?preview=<version>` (see README "Running custom UI on devint/qa
// without deploy"), the on-demand ones are set manually or by the e2e fixtures (see README "On-demand environments").
export const ENV_OVERRIDE_COOKIES = [
  { label: 'UI version', name: 'ox_ui_version' },
  { label: 'On-demand API env', name: 'ox_ondemand_env' },
  { label: 'On-demand FACADE env', name: 'ox_ondemand_facade_env' },
] as const;

// oa-nginx also expires ox_ui_oa_version on `?preview=clear`, so reset drops it as well
export const ENV_OVERRIDE_CLEAR_COOKIES = [...ENV_OVERRIDE_COOKIES.map(({ name }) => name), 'ox_ui_oa_version'];
